module.exports = __webpack_public_path__ + "static/img/xiaohongshu.dd306a21.png";